import { IFichaSSoAvanceModel } from "../interfaces/ficha-sso/IFichaSSoAvanceModel";

export class FichaSSoAvanceModel implements IFichaSSoAvanceModel{
    completados: number;
    total:number;
    avance:number;
    constructor(){
        this.completados=0;
        this.total=0;
        this.avance=0;
    }
}